exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-tlist[data-v-26d3d4d7] {\n  border: none;\n}", ""]);

// exports
